<template>
  <div
    class="view-content"
  >
    <MaterialCard class="notes">
      <div
        v-for="release in releaseNotes"
        :id="formatId(release.version)"
        :key="release.version"
        class="note"
        v-html="release.html"
      />
      <div class="sidebar">
        <div class="sidebar-in">
          <h1 class="view-title ma-0 pa-1 pl-2">
            リリースノート
          </h1>
          <ul class="list-container mt-3 pr-4">
            <li
              v-for="{ version } in releaseNotes"
              :key="version"
              class="list-item pl-1"
              @click="scroll(version)"
            >
              {{ version }}
            </li>
          </ul>
        </div>
      </div>
    </MaterialCard>
  </div>
</template>

<script>
import releaseNotes from '@/contents/announces/releaseNotes.json'
export default {
  data () {
    return {
      releaseNotes
    }
  },
  methods: {
    formatId (id) {
      return 'v' + id.split('.').join('')
    },
    scroll (target) {
      this.$vuetify.goTo(`#${this.formatId(target)}`, {
        duration: 500,
        offset: 75,
        easing: 'easeInOutCubic'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.view-content{
  position: relative;
  margin-top: 80px;
  padding-left: 75px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sidebar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -150px;
  width: 150px;

  &-in {
    position: fixed;
    width: 150px;
    top: 96px;
    overflow: hidden;
  }

  .view-title {
    width: 100%;
    box-shadow: 0 1px 0px rgba(0, 0, 0, 0.14);
    white-space: nowrap;
    font-size: 1.1rem;
  }

  .list-container {
    list-style: "#" outside;
    overflow-y: scroll;
    width: 118px;
    height: 75vh;
    padding-left: 32px;
    box-sizing: content-box;
  }

  .list-item {
    font-size: 1rem;
    line-height: 1.5;
    cursor: pointer;
    transition: font-weight .2s;
    &:hover {
      font-weight: 500;
    }
  }
}

.notes {
  width: 980px;
  max-width: 85%;
  padding: 10px 48px;
  line-height: 2rem;
  font-size: 1.1rem;
  color: #222;

  .note {
    &:not(:first-child) {
      margin-top: 48px;
    }
    /deep/ {
      &h1, &h2, &h3, &h4, &h5, &h6 {
        font-weight: 700;
        margin: 1em 0;
        color: #333;
      }
      &h2 {
        font-size: 1.8rem;
        line-height: 3.2rem;
        padding: 8px 0 6px;
        border-bottom: solid 3px var(--metal-blue);
      }
      &h3 {
        font-size: 1.3rem;
        line-height: 2.8rem;
        padding: 6px 0;
        border-bottom: solid 1px var(--metal-blue);
      }
      &h4 {
        font-size: 1.2rem;
        line-height: 2.4rem;
      }
      &p {
        margin: 1.4em 0;
        white-space: pre-wrap;
      }
    }
  }
}
</style>
